import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateColumnsDefinition
 */

type DocumentoProps = {
  onActionEdit: (id: number | undefined) => void,
  onActionDelete: (id: number | undefined) => void,
  onDownload: (idFuncionarioArquivo: number, imageName: string) => void,
};

export const GenerateDocumentoColumnsDefinition = ({
  onActionEdit,
  onActionDelete,
  onDownload,
}: DocumentoProps): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "E";
      case 2:
        return "V";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "yellow";
      case 2:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Em dia";
      case 2:
        return "Vencido";
      default:
        return "?";
    }
  };

  const computeItemSituacaoTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Atual";
      case 2:
        return "Obsoleto";
      default:
        return "?";
    }
  };

  const computeItemSituacaoColor = (status: number) => {
    switch (status) {
      case 1:
        return "#45b6af";
      case 2:
        return "#f3565d";
      default:
        return "blue";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 60,
      flex: 0,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          {params.value > 0 &&
            <ItemStatus
              title={computeItemStatusTitle(params.value)}
              color={computeItemStatusColor(params.value)}
              description={computeItemStatusDescription(params.value)} />}
        </div>
      )
    },
    {
      field: "situacao",
      filterable: false,
      headerName: "Situação",
      flex: 0,
      minWidth: 80,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <div>
            <span
              className='inline px-2 py-1 text-sm rounded'
              style={{ backgroundColor: computeItemSituacaoColor(params.value) }}>
              {computeItemSituacaoTitle(params.value)}
            </span>
          </div>
        </div>
      )
    },
    {
      field: "dataVencimento",
      filterable: false,
      headerName: "Data de vencimento",
      minWidth: 150,
      flex: 0,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div>{params.value !== null && dayjs.utc(params.value).local().format('DD/MM/YYYY')}</div>
        );
      }
    },
    {
      field: "dataEmissao",
      filterable: false,
      headerName: "Data de emissão",
      minWidth: 150,
      flex: 0,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: (params) => {
        return (
          <div>{params.value !== null && dayjs.utc(params.value).local().format('DD/MM/YYYY')}</div>
        );
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      minWidth: 150,
      flex: 2,
      sortable: false,
      headerClassName: 'funcionarios-header'
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Arquivo",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        arquivoNome: rows['nome'],
        idDocumento: rows['idDocumento'],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const arquivoNome = params.value['arquivoNome'] as string;
        const idDocumento = params.value['idDocumento'] as number;

        return (
          <Button
            onMouseDown={() => onDownload(idDocumento, arquivoNome)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.3rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
              width: '9.5rem',
            }}>
            {arquivoNome && arquivoNome.length > maxSize ? `${arquivoNome.substring(0, maxSize)}...` : arquivoNome}
          </Button>
        );
      },
    },
    {
      field: 'idDocumento',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 0,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEdit(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDelete(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}

